/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import { dataService } from '../../services/data.service';
import ApplicationContext from '../../context/ApplicationContext';
import AnimatedButton from '../../components/Button';
import './styles.css';
import ThreeDotsBlackLoader from '../../components/LoadingDots/ThreeDotsBlack';
import { generateDeviceFingerprint } from '../../helpers/CommonFunctions';
import { appointmentLanguageContent } from './appointmentLanguageContent';
import { backNextLanguageContent } from '../../components/Button/backNextLanguageContent';

function CancelAppointment() {
    const { facilityData, handlePage, currentAppointment, selectedLanguage, selectedLanguageName } = useContext(ApplicationContext);
    const [selectedReason, setSelectedReason] = useState(facilityData.cancellation_reasons[0]);
    const [loading, setLoading] = useState(false);

    const handleStatusChange = (status) => {
        setLoading(true);
        const payload = {
            "patient_id": currentAppointment.patient_id,
            "fingerprint_id": generateDeviceFingerprint(),
            "appointment_status": status,
            "cancellation_reason": selectedReason
        }
        dataService.changeAppointmentStatus(sessionStorage.getItem('session'), payload).then((res) => {
            setLoading(false);
            if(res.error === false) {
                handlePage('thankyou');
            } else {
                handleToast(res.data.data.message);
            }
        })
    };

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-hidden'>
            <div className='p-[8px]'>
                <p className='text-center font-semibold text-[#64A003] text-[24px] border-b border-[#D7D7D7] py-[5px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] flex justify-center items-center'>
                    <AnimatedImage url="/images/Calendar.svg" alt="calendar" className="mr-[12px]" />
                    <p className={selectedLanguage === 'ar' ? 'dir-rtl' : ''}>{appointmentLanguageContent['appointment'][selectedLanguage]}</p>
                </p>
                {appointmentLanguageContent['cancel-text'][selectedLanguage]}
                <div className={`mt-[26px] ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>
                    <div className="px-1 custom-checkbox5 max-w-[95%]" data-testid="appointment_reasons">
                        {facilityData.cancellation_reasons.map((item, index) => (
                            item[selectedLanguageName] !== '' && item[selectedLanguageName] !== undefined && 
                            <div key={`cancel-${index}`} className="relative custom-radioBlue flex items-center mb-[13px]">
                                <input id={`radio-${index}`} type="radio" name="default-radio1" checked={selectedReason === item[selectedLanguageName]} onChange={()=>setSelectedReason(item[selectedLanguageName])}/>
                                <label style={{overflowWrap: 'anywhere'}} htmlFor={`radio-${index}`} className={`flex text-sm font-normal text-[#333] pl-[30px] relative cursor-pointer blood-group-label break-words`}>
                                    {item[selectedLanguageName]}
                                </label>
                            </div>
                        ))}
                        <div key={`cancel-other`} className="relative custom-radioBlue flex items-center">
                            <input id={`radio-other`} type="radio" name="default-radio1" checked={selectedReason === 'Other'} onChange={()=>setSelectedReason('Other')}/>
                            <label data-testid="other" htmlFor={`radio-other`} className={`flex text-sm font-normal text-[#333] pl-[30px] relative cursor-pointer blood-group-label`}>
                                {appointmentLanguageContent['other'][selectedLanguage]}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex mb-[24px] justify-between mx-[16px] w-auto fold-gap'>
                <AnimatedButton handleClick={() => handlePage('appointment_options')} 
                    disabled={loading} id="options-btn" className={`font-semibold text-gray bg-[#F2F2F2] w-[131px] h-[40px] text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-start fold-normal-text`}>
                    <img src="/images/Back.svg" alt="back" className='ml-[10px] w-[1.7em] h-[1.7em] mr-[10px] fold-m-10' />
                    {backNextLanguageContent['back'][selectedLanguage]}
                </AnimatedButton>
                <AnimatedButton handleClick={() => handleStatusChange('Cancelled')} 
                    disabled={loading} id="confirm_button" className={`font-semibold min-w-fit text-gray bg-[#F2F2F2] w-[165px] h-[40px] text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-center fold-normal-text`}>
                    {!loading && <img src="/images/Calendar check.svg" alt="next" className='ml-[1.2em] w-[1.7em] h-[1.7em] mr-[10px]' />}
                    {loading ? <ThreeDotsBlackLoader /> : appointmentLanguageContent['confirm'][selectedLanguage]}
                    {!loading && <img src="/images/next.svg" alt="next" className='ml-[0.5em] w-[1.7em] h-[1.7em]' />}
                </AnimatedButton>
            </div>
        </AnimatedPageFade>
    );
}

export default CancelAppointment;